import { Longhand } from "../longhand.js";
import Base from "./wrap-before.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/wrap-after}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=wrap-after.js.map